import { motion } from "framer-motion";
import { Castle, Layers, Waves, Flag, Target, Droplets } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

const OFFERINGS = [
    { icon: Castle, name: "Bounce Houses", blurb: "Classic castles and themed bouncers for every size of party.", color: "bg-monster-blue" },
    { icon: Layers, name: "Bounce House + Slide Combos", blurb: "Bounce, climb, and slide — all in one giant unit.", color: "bg-monster-green" },
    { icon: Waves, name: "Water Slides", blurb: "Towering slides with splash landings for hot summer days.", color: "bg-monster-yellow" },
    { icon: Flag, name: "Obstacle Courses", blurb: "Tunnels, pop-ups, and climbing walls built for racing.", color: "bg-monster-red" },
    { icon: Target, name: "Party Games", blurb: "Axe throwing, basketball, soccer, and more crowd-pleasers.", color: "bg-[#B04DFF]" },
    { icon: Droplets, name: "Dunk Tanks", blurb: "Dunk dad, dunk the coach — hundreds of gallons of pure comedy.", color: "bg-white" },
];

export const Pricing = () => (
    <section id="packages" data-testid="offerings-section" className="border-y-2 border-monster-navy bg-monster-sky py-24 sm:py-32">
        <div className="mx-auto max-w-6xl px-5">
            <SectionHeading
                number="01"
                title="What we're"
                highlight="bringing."
                sub="The full Monsters Inflatables arsenal, rolling out Spring 2027. Every rental includes free delivery, professional setup, takedown, and a pre-party safety check."
            />
            <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {OFFERINGS.map((o, i) => (
                    <motion.div
                        key={o.name}
                        data-testid={`offering-card-${i}`}
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        viewport={{ once: true, margin: "-60px" }}
                        transition={{ type: "spring", stiffness: 80, damping: 15, delay: (i % 3) * 0.12 }}
                        whileHover={{ y: -8, rotate: i % 2 === 0 ? -0.8 : 0.8 }}
                        className="rounded-[32px] border-2 border-monster-navy bg-white p-8 shadow-sticker"
                    >
                        <span className={`flex h-14 w-14 items-center justify-center rounded-2xl border-2 border-monster-navy shadow-sticker-sm ${o.color}`}>
                            <o.icon className={`h-7 w-7 ${o.color === "bg-white" || o.color === "bg-monster-yellow" || o.color === "bg-monster-green" ? "text-monster-navy" : "text-white"}`} />
                        </span>
                        <h3 className="mt-5 font-display text-xl font-semibold text-monster-navy">{o.name}</h3>
                        <p className="mt-2 text-sm font-semibold leading-relaxed text-monster-navy/65">{o.blurb}</p>
                    </motion.div>
                ))}
            </div>
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ type: "spring", stiffness: 90, damping: 15 }}
                className="mt-14 flex flex-col items-center gap-4"
            >
                <button
                    data-testid="offerings-join-list-btn"
                    onClick={() => document.querySelector("#launch-list")?.scrollIntoView({ behavior: "smooth" })}
                    className="rounded-full border-2 border-monster-navy bg-monster-blue px-8 py-4 font-display text-base font-semibold text-white shadow-sticker transition-all hover:-translate-y-0.5 hover:bg-[#1a63c2] active:translate-y-1 active:shadow-none"
                >
                    Join the Launch List for 20% Off
                </button>
                <p className="text-sm font-semibold text-monster-navy/50">
                    Need something custom? Call <a href="tel:+18104441076" className="text-monster-blue underline">(810) 444-1076</a> and we'll build your perfect party.
                </p>
            </motion.div>
        </div>
    </section>
);
